import React, { useState, useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { useLanguage } from './context/languageContext';

function Article() {
  const { slug } = useParams();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const [article, setArticle] = useState(null);
  const { language, setLanguage } = useLanguage();

  useEffect(() => {
    const queryLang = queryParams.get('lang');
    if (queryLang === 'bel' || queryLang === 'rus') {
      setLanguage(queryLang);
    }
  }, []);

  useEffect(() => {
    fetch(`/api/articles/${slug}`)
      .then((response) => {
        if (!response.ok) {
          throw new Error('Статья не найдена');
        }
        return response.json();
      })
      .then((data) => setArticle(data))
      .catch((error) => {
        console.error('Ошибка получения статьи:', error);
        setArticle(null);
      });
  }, [slug]);

  if (!article) return <p>Загрузка...</p>;

  return (
    <div className="tgme_page">
      <div className="tgme_page_wrap">
        <h1 className="tgme_page_title">{language === 'rus' ? article.title : article.titleBel}</h1>
        <p className="article-author">Автор: {article.author.username}</p>
        <hr className="article-divider" />
        <div
          className="tgme_page_content"
          dangerouslySetInnerHTML={{
            __html: language === 'rus' ? article.content : article.contentBel,
          }}></div>
      </div>
    </div>
  );
}

export default Article;
